"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tabClassNames: ()=>tabClassNames,
    useTabStyles_unstable: ()=>useTabStyles_unstable
});
const _react = require("@griffel/react");
const _useTabAnimatedIndicator = require("./useTabAnimatedIndicator");
const tabClassNames = {
    root: 'fui-Tab',
    icon: 'fui-Tab__icon',
    content: 'fui-Tab__content'
};
const reservedSpaceClassNames = {
    content: 'fui-Tab__content--reserved-space'
};
// These should match the constants defined in @fluentui/react-icons
// This package avoids taking a dependency on the icons package for only the constants.
const iconClassNames = {
    filled: 'fui-Icon-filled',
    regular: 'fui-Icon-regular'
};
/**
 * Styles for the root slot
 */ /* eslint-disable @typescript-eslint/naming-convention */ const useRootStyles = /*#__PURE__*/ (0, _react["__styles"])({
    base: {
        Bt984gj: "f122n59",
        g2u3we: "fwhevhj",
        h3c5rm: [
            "f61n433",
            "f1q8l70w"
        ],
        B9xav0g: "fv1dfc8",
        zhjwy3: [
            "f1q8l70w",
            "f61n433"
        ],
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ],
        B4j52fo: "fre7gi1",
        Bekrc4i: [
            "f1358rze",
            "f1rvrf73"
        ],
        Bn0qgzm: "fqdk4by",
        ibv6hh: [
            "f1rvrf73",
            "f1358rze"
        ],
        Bceei9c: "f1k6fduh",
        mc9l5x: "f13qh94s",
        Bnnss6s: "fi64zpg",
        Bxotwcr: "f1u07yai",
        Budl1dq: "frn2hmy",
        wkccdc: "f1olsevy",
        Bahqtrf: "fk6fouc",
        Bg96gwp: "f1i3iumi",
        oeaueh: "f1s6fcnf",
        qhf8xq: "f10pi13n",
        B68tc82: "f1p9o1ba",
        Bmxbyg5: "f1sil6mw",
        B9bfxx9: "f1cxpek8"
    },
    horizontal: {
        Brf1p80: "f4d9j23"
    },
    vertical: {
        Brf1p80: "f1s9ku6b"
    },
    smallHorizontal: {
        i8kkvl: "f14mj54c",
        z8tnut: "fp2oml8",
        z189sj: [
            "fdw0yi8",
            "fk8j09s"
        ],
        Byoj8tv: "f1tdddsa",
        uwmqm3: [
            "fk8j09s",
            "fdw0yi8"
        ]
    },
    smallVertical: {
        i8kkvl: "f14mj54c",
        z8tnut: "fclwglc",
        z189sj: [
            "fdw0yi8",
            "fk8j09s"
        ],
        Byoj8tv: "fywfov9",
        uwmqm3: [
            "fk8j09s",
            "fdw0yi8"
        ]
    },
    mediumHorizontal: {
        i8kkvl: "f1rjii52",
        z8tnut: "f5yzyt",
        z189sj: [
            "f11gcy0p",
            "f1ng84yb"
        ],
        Byoj8tv: "fx3omr",
        uwmqm3: [
            "f1ng84yb",
            "f11gcy0p"
        ]
    },
    mediumVertical: {
        i8kkvl: "f1rjii52",
        z8tnut: "fp2oml8",
        z189sj: [
            "f11gcy0p",
            "f1ng84yb"
        ],
        Byoj8tv: "f1tdddsa",
        uwmqm3: [
            "f1ng84yb",
            "f11gcy0p"
        ]
    },
    largeHorizontal: {
        i8kkvl: "f1rjii52",
        z8tnut: "fikn0iw",
        z189sj: [
            "f11gcy0p",
            "f1ng84yb"
        ],
        Byoj8tv: "fdxej3c",
        uwmqm3: [
            "f1ng84yb",
            "f11gcy0p"
        ]
    },
    largeVertical: {
        i8kkvl: "f1rjii52",
        z8tnut: "f1kwiid1",
        z189sj: [
            "f11gcy0p",
            "f1ng84yb"
        ],
        Byoj8tv: "f5b47ha",
        uwmqm3: [
            "f1ng84yb",
            "f11gcy0p"
        ]
    },
    transparent: {
        De3pzq: "f1c21dwh",
        Jwef8y: "fjxutwb",
        ecr2s2: "fophhak",
        Bptxc3x: "fmmjozx",
        B076xvk: "f1mfqf41",
        q9r9w5: "f10aiid4",
        cl4aha: "fpkze5g",
        Bk452zc: "f149wc3x",
        a4hkcw: "fjioou7"
    },
    subtle: {
        De3pzq: "fhovq9v",
        Jwef8y: "f1t94bn6",
        ecr2s2: "f1wfn5kd",
        Bptxc3x: "fmmjozx",
        B076xvk: "f1mfqf41",
        q9r9w5: "f10aiid4",
        cl4aha: "fpkze5g",
        Bk452zc: "f149wc3x",
        a4hkcw: "fjioou7"
    },
    disabled: {
        De3pzq: "f1c21dwh",
        Bptxc3x: "fato7r6",
        cl4aha: "fao1bnu",
        Bceei9c: "fdrzuqr"
    },
    selected: {
        Bptxc3x: "f1cadz5z",
        B076xvk: "f1ck17l",
        q9r9w5: "f42ak0g",
        cl4aha: "ffplhdr",
        Bk452zc: "ffth601",
        a4hkcw: "fhklyu5"
    }
}, {
    d: [
        ".f122n59{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}",
        ".fwhevhj{border-top-color:none;}",
        ".f61n433{border-right-color:none;}",
        ".f1q8l70w{border-left-color:none;}",
        ".fv1dfc8{border-bottom-color:none;}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".fre7gi1{border-top-width:0;}",
        ".f1358rze{border-right-width:0;}",
        ".f1rvrf73{border-left-width:0;}",
        ".fqdk4by{border-bottom-width:0;}",
        ".f1k6fduh{cursor:pointer;}",
        ".f13qh94s{display:grid;}",
        ".fi64zpg{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;}",
        ".f1u07yai{grid-auto-flow:column;}",
        ".frn2hmy{grid-template-columns:auto;}",
        ".f1olsevy{grid-template-rows:auto;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".f1s6fcnf{outline-style:none;}",
        ".f10pi13n{position:relative;}",
        ".f1p9o1ba{overflow-x:hidden;}",
        ".f1sil6mw{overflow-y:hidden;}",
        ".f1cxpek8{text-transform:none;}",
        ".f4d9j23{-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;}",
        ".f1s9ku6b{-webkit-box-pack:start;-ms-flex-pack:start;-webkit-justify-content:start;justify-content:start;}",
        ".f14mj54c{-webkit-column-gap:var(--spacingHorizontalXXS);column-gap:var(--spacingHorizontalXXS);}",
        ".fp2oml8{padding-top:var(--spacingVerticalSNudge);}",
        ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}",
        ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}",
        ".f1tdddsa{padding-bottom:var(--spacingVerticalSNudge);}",
        ".fclwglc{padding-top:var(--spacingVerticalXXS);}",
        ".fywfov9{padding-bottom:var(--spacingVerticalXXS);}",
        ".f1rjii52{-webkit-column-gap:var(--spacingHorizontalSNudge);column-gap:var(--spacingHorizontalSNudge);}",
        ".f5yzyt{padding-top:var(--spacingVerticalM);}",
        ".f11gcy0p{padding-right:var(--spacingHorizontalMNudge);}",
        ".f1ng84yb{padding-left:var(--spacingHorizontalMNudge);}",
        ".fx3omr{padding-bottom:var(--spacingVerticalM);}",
        ".fikn0iw{padding-top:var(--spacingVerticalL);}",
        ".fdxej3c{padding-bottom:var(--spacingVerticalL);}",
        ".f1kwiid1{padding-top:var(--spacingVerticalS);}",
        ".f5b47ha{padding-bottom:var(--spacingVerticalS);}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".fmmjozx .fui-Tab__icon{color:var(--colorNeutralForeground2);}",
        ".fpkze5g .fui-Tab__content{color:var(--colorNeutralForeground2);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".fato7r6 .fui-Tab__icon{color:var(--colorNeutralForegroundDisabled);}",
        ".fao1bnu .fui-Tab__content{color:var(--colorNeutralForegroundDisabled);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1cadz5z .fui-Tab__icon{color:var(--colorCompoundBrandForeground1);}",
        ".ffplhdr .fui-Tab__content{color:var(--colorNeutralForeground1);}"
    ],
    h: [
        ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".f1mfqf41:hover .fui-Tab__icon{color:var(--colorNeutralForeground2Hover);}",
        ".f149wc3x:hover .fui-Tab__content{color:var(--colorNeutralForeground2Hover);}",
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".f1ck17l:hover .fui-Tab__icon{color:var(--colorCompoundBrandForeground1Hover);}",
        ".ffth601:hover .fui-Tab__content{color:var(--colorNeutralForeground1Hover);}"
    ],
    a: [
        ".fophhak:active{background-color:var(--colorTransparentBackgroundPressed);}",
        ".f10aiid4:active .fui-Tab__icon{color:var(--colorNeutralForeground2Pressed);}",
        ".fjioou7:active .fui-Tab__content{color:var(--colorNeutralForeground2Pressed);}",
        ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".f42ak0g:active .fui-Tab__icon{color:var(--colorCompoundBrandForeground1Pressed);}",
        ".fhklyu5:active .fui-Tab__content{color:var(--colorNeutralForeground1Pressed);}"
    ]
});
/* eslint-enable @typescript-eslint/naming-convention */ /**
                                                         * Focus styles for the root slot
                                                         */ const useFocusStyles = /*#__PURE__*/ (0, _react["__styles"])({
    base: {
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bn4voq9: "f1p7hgxw",
        Bfpq7zp: "f1way5bb",
        g9k6zt: "f9znhxp",
        j6ew2k: [
            "fqa318h",
            "fqa318h"
        ],
        Bhxq17a: "f1vjpng2"
    }
}, {
    d: [
        ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",
        ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",
        ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",
        ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",
        ".f1p7hgxw[data-fui-focus-visible]{outline-width:var(--strokeWidthThick);}",
        ".f1way5bb[data-fui-focus-visible]{outline-color:transparent;}",
        ".f9znhxp[data-fui-focus-visible]{outline-style:solid;}",
        ".fqa318h[data-fui-focus-visible]{box-shadow:var(--shadow4),0 0 0 var(--strokeWidthThick) var(--colorStrokeFocus2);}",
        ".f1vjpng2[data-fui-focus-visible]{z-index:1;}"
    ]
});
/** Indicator styles for when pending selection */ const usePendingIndicatorStyles = /*#__PURE__*/ (0, _react["__styles"])({
    base: {
        az7l2e: "fhw179n",
        Bv4n3vi: [
            "f10y1uxy",
            "f6aiuy0"
        ],
        vqofr: [
            "f6aiuy0",
            "f10y1uxy"
        ],
        B0uxbk8: [
            "f1kfpfnu",
            "f1dx5wco"
        ],
        Bgqb9hq: [
            "f1dx5wco",
            "f1kfpfnu"
        ],
        amg5m6: "f1kmhr4c",
        zkfqfm: "fl1ydde",
        Bkydozb: "f1y7maxz",
        vzq8l0: [
            "f105swax",
            "fscdmel"
        ],
        Bka2azo: [
            "fscdmel",
            "f105swax"
        ],
        Br4ovkg: [
            "f1tkcw1w",
            "f1u11x8o"
        ],
        csmgbd: [
            "f1u11x8o",
            "f1tkcw1w"
        ],
        y36c18: "f16cxu0",
        B1ctymy: "f1nwgacf",
        Bgvrrv0: "f15ovonk",
        ddr6p5: "fvje46l"
    },
    disabled: {
        az7l2e: "f1ut20fw",
        Bkydozb: "fhrzcfn"
    },
    smallHorizontal: {
        lawp4y: "fchca7p",
        Baz25je: "f1r53b5e",
        Fbdkly: [
            "f1s6rxz5",
            "fo35v8s"
        ],
        mdwyqc: [
            "fo35v8s",
            "f1s6rxz5"
        ]
    },
    smallVertical: {
        lawp4y: "fze4zud",
        Fbdkly: [
            "f1fzr1x6",
            "f1f351id"
        ],
        Bciustq: "fdp32p8",
        Ccq8qp: "f1aij3q"
    },
    mediumHorizontal: {
        lawp4y: "fchca7p",
        Baz25je: "f1s2r9ax",
        Fbdkly: [
            "f1o0nnkk",
            "fxb7rol"
        ],
        mdwyqc: [
            "fxb7rol",
            "f1o0nnkk"
        ]
    },
    mediumVertical: {
        lawp4y: "f17jracn",
        Fbdkly: [
            "f1fzr1x6",
            "f1f351id"
        ],
        Bciustq: "f117lcb2",
        Ccq8qp: "f1aij3q"
    },
    largeHorizontal: {
        lawp4y: "fchca7p",
        Baz25je: "f1s2r9ax",
        Fbdkly: [
            "f1o0nnkk",
            "fxb7rol"
        ],
        mdwyqc: [
            "fxb7rol",
            "f1o0nnkk"
        ]
    },
    largeVertical: {
        lawp4y: "fel9d3z",
        Fbdkly: [
            "f1fzr1x6",
            "f1f351id"
        ],
        Bciustq: "f6vqlre",
        Ccq8qp: "f1aij3q"
    }
}, {
    h: [
        ".fhw179n:hover::before{background-color:var(--colorNeutralStroke1Hover);}",
        ".f10y1uxy:hover::before{border-bottom-right-radius:var(--borderRadiusCircular);}",
        ".f6aiuy0:hover::before{border-bottom-left-radius:var(--borderRadiusCircular);}",
        ".f1kfpfnu:hover::before{border-top-right-radius:var(--borderRadiusCircular);}",
        ".f1dx5wco:hover::before{border-top-left-radius:var(--borderRadiusCircular);}",
        ".f1kmhr4c:hover::before{content:\"\";}",
        ".fl1ydde:hover::before{position:absolute;}",
        ".f1ut20fw:hover::before{background-color:var(--colorTransparentStroke);}"
    ],
    a: [
        ".f1y7maxz:active::before{background-color:var(--colorNeutralStroke1Pressed);}",
        ".f105swax:active::before{border-bottom-right-radius:var(--borderRadiusCircular);}",
        ".fscdmel:active::before{border-bottom-left-radius:var(--borderRadiusCircular);}",
        ".f1tkcw1w:active::before{border-top-right-radius:var(--borderRadiusCircular);}",
        ".f1u11x8o:active::before{border-top-left-radius:var(--borderRadiusCircular);}",
        ".f16cxu0:active::before{content:\"\";}",
        ".f1nwgacf:active::before{position:absolute;}",
        ".fhrzcfn:active::before{background-color:var(--colorTransparentStroke);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f15ovonk:hover::before{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fvje46l:active::before{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    d: [
        ".fchca7p::before{bottom:0;}",
        ".f1r53b5e::before{height:var(--strokeWidthThick);}",
        ".f1s6rxz5::before{left:var(--spacingHorizontalSNudge);}",
        ".fo35v8s::before{right:var(--spacingHorizontalSNudge);}",
        ".fze4zud::before{bottom:var(--spacingVerticalXS);}",
        ".f1fzr1x6::before{left:0;}",
        ".f1f351id::before{right:0;}",
        ".fdp32p8::before{top:var(--spacingVerticalXS);}",
        ".f1aij3q::before{width:var(--strokeWidthThicker);}",
        ".f1s2r9ax::before{height:var(--strokeWidthThicker);}",
        ".f1o0nnkk::before{left:var(--spacingHorizontalM);}",
        ".fxb7rol::before{right:var(--spacingHorizontalM);}",
        ".f17jracn::before{bottom:var(--spacingVerticalS);}",
        ".f117lcb2::before{top:var(--spacingVerticalS);}",
        ".fel9d3z::before{bottom:var(--spacingVerticalMNudge);}",
        ".f6vqlre::before{top:var(--spacingVerticalMNudge);}"
    ]
});
const useActiveIndicatorStyles = /*#__PURE__*/ (0, _react["__styles"])({
    base: {
        Bjyk6c5: "f1rp0jgh",
        B3778ie: [
            "fprarqb",
            "f14vs0nd"
        ],
        d9w3h3: [
            "f14vs0nd",
            "fprarqb"
        ],
        Bl18szs: [
            "f1gtfqs9",
            "f18zvfd9"
        ],
        B4j8arr: [
            "f18zvfd9",
            "f1gtfqs9"
        ],
        Bsft5z2: "f13zj6fq",
        E3zdtr: "f1mdlcz9",
        t2ki1e: "ffmd2fr"
    },
    selected: {
        Bjyk6c5: "f1ksivud",
        Glksuk: "f1eytvvh",
        Blzl0y7: "fuaa9s",
        f7digc: "fy7ktjt",
        Biqphg1: "f16tp0gf",
        Bntoloa: "fj0yp7j"
    },
    disabled: {
        Bjyk6c5: "f13lkzet"
    },
    smallHorizontal: {
        By385i5: "fo72kxq",
        Dlnsje: "f9bb2ob",
        Eqx8gd: [
            "f1q70ajw",
            "f18rbzdx"
        ],
        B1piin3: [
            "f18rbzdx",
            "f1q70ajw"
        ]
    },
    smallVertical: {
        By385i5: "fqbue9b",
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        bn5sak: "fk1klkt",
        a2br6o: "f1o25lip"
    },
    mediumHorizontal: {
        By385i5: "fo72kxq",
        Dlnsje: "f1vx7lu8",
        Eqx8gd: [
            "fna7m5n",
            "f1oxpfwv"
        ],
        B1piin3: [
            "f1oxpfwv",
            "fna7m5n"
        ]
    },
    mediumVertical: {
        By385i5: "fipylg0",
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        bn5sak: "fqchiol",
        a2br6o: "f1o25lip"
    },
    largeHorizontal: {
        By385i5: "fo72kxq",
        Dlnsje: "f1vx7lu8",
        Eqx8gd: [
            "fna7m5n",
            "f1oxpfwv"
        ],
        B1piin3: [
            "f1oxpfwv",
            "fna7m5n"
        ]
    },
    largeVertical: {
        By385i5: "f1w7dm5g",
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        bn5sak: "f1p6em4m",
        a2br6o: "f1o25lip"
    }
}, {
    d: [
        ".f1rp0jgh::after{background-color:var(--colorTransparentStroke);}",
        ".fprarqb::after{border-bottom-right-radius:var(--borderRadiusCircular);}",
        ".f14vs0nd::after{border-bottom-left-radius:var(--borderRadiusCircular);}",
        ".f1gtfqs9::after{border-top-right-radius:var(--borderRadiusCircular);}",
        ".f18zvfd9::after{border-top-left-radius:var(--borderRadiusCircular);}",
        ".f13zj6fq::after{content:\"\";}",
        ".f1mdlcz9::after{position:absolute;}",
        ".ffmd2fr::after{z-index:1;}",
        ".f1ksivud::after{background-color:var(--colorCompoundBrandStroke);}",
        ".f13lkzet::after{background-color:var(--colorNeutralForegroundDisabled);}",
        ".fo72kxq::after{bottom:0;}",
        ".f9bb2ob::after{height:var(--strokeWidthThick);}",
        ".f1q70ajw::after{left:var(--spacingHorizontalSNudge);}",
        ".f18rbzdx::after{right:var(--spacingHorizontalSNudge);}",
        ".fqbue9b::after{bottom:var(--spacingVerticalXS);}",
        ".f1n6gb5g::after{left:0;}",
        ".f15yvnhg::after{right:0;}",
        ".fk1klkt::after{top:var(--spacingVerticalXS);}",
        ".f1o25lip::after{width:var(--strokeWidthThicker);}",
        ".f1vx7lu8::after{height:var(--strokeWidthThicker);}",
        ".fna7m5n::after{left:var(--spacingHorizontalM);}",
        ".f1oxpfwv::after{right:var(--spacingHorizontalM);}",
        ".fipylg0::after{bottom:var(--spacingVerticalS);}",
        ".fqchiol::after{top:var(--spacingVerticalS);}",
        ".f1w7dm5g::after{bottom:var(--spacingVerticalMNudge);}",
        ".f1p6em4m::after{top:var(--spacingVerticalMNudge);}"
    ],
    h: [
        ".f1eytvvh:hover::after{background-color:var(--colorCompoundBrandStrokeHover);}"
    ],
    a: [
        ".fuaa9s:active::after{background-color:var(--colorCompoundBrandStrokePressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.fy7ktjt::after{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f16tp0gf:hover::after{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fj0yp7j:active::after{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
/**
 * Styles for the icon slot.
 */ const useIconStyles = /*#__PURE__*/ (0, _react["__styles"])({
    base: {
        Br312pm: "fwpfdsa",
        Ijaq50: "f16hsg94",
        Bt984gj: "f122n59",
        mc9l5x: "ftuwxu6",
        Brf1p80: "f4d9j23",
        B68tc82: "f1p9o1ba",
        Bmxbyg5: "f1sil6mw",
        D0sxk3: "f16u1re",
        t6yez3: "f8bsbmo"
    },
    small: {
        Be2twd7: "fe5j1ua",
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3"
    },
    medium: {
        Be2twd7: "fe5j1ua",
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3"
    },
    large: {
        Be2twd7: "f1rt2boy",
        Bqenvij: "frvgh55",
        a9b677: "fq4mcun"
    },
    selected: {
        D0sxk3: "fxoiby5",
        t6yez3: "f15q0o9g"
    }
}, {
    d: [
        ".fwpfdsa{grid-column-start:1;}",
        ".f16hsg94{grid-row-start:1;}",
        ".f122n59{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}",
        ".ftuwxu6{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;}",
        ".f4d9j23{-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;}",
        ".f1p9o1ba{overflow-x:hidden;}",
        ".f1sil6mw{overflow-y:hidden;}",
        ".f16u1re .fui-Icon-filled{display:none;}",
        ".f8bsbmo .fui-Icon-regular{display:inline;}",
        ".fe5j1ua{font-size:20px;}",
        ".fjamq6b{height:20px;}",
        ".f64fuq3{width:20px;}",
        ".f1rt2boy{font-size:24px;}",
        ".frvgh55{height:24px;}",
        ".fq4mcun{width:24px;}",
        ".fxoiby5 .fui-Icon-filled{display:inline;}",
        ".f15q0o9g .fui-Icon-regular{display:none;}"
    ]
});
/**
 * Styles for the content slot (children)
 */ const useContentStyles = /*#__PURE__*/ (0, _react["__styles"])({
    base: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        B68tc82: "f1p9o1ba",
        Bmxbyg5: "f1sil6mw",
        z8tnut: "fztplxc",
        z189sj: [
            "ffczdla",
            "fgiv446"
        ],
        Byoj8tv: "f9g1xly",
        uwmqm3: [
            "fgiv446",
            "ffczdla"
        ]
    },
    selected: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1i3iumi"
    },
    large: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "figsok6",
        Bg96gwp: "faaz57k"
    },
    largeSelected: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    noIconBefore: {
        Br312pm: "fwpfdsa",
        Ijaq50: "f16hsg94"
    },
    iconBefore: {
        Br312pm: "fd46tj4",
        Ijaq50: "f16hsg94"
    },
    placeholder: {
        Bcdw1i0: "fd7fpy0"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".f1p9o1ba{overflow-x:hidden;}",
        ".f1sil6mw{overflow-y:hidden;}",
        ".fztplxc{padding-top:var(--spacingVerticalNone);}",
        ".ffczdla{padding-right:var(--spacingHorizontalXXS);}",
        ".fgiv446{padding-left:var(--spacingHorizontalXXS);}",
        ".f9g1xly{padding-bottom:var(--spacingVerticalNone);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fwpfdsa{grid-column-start:1;}",
        ".f16hsg94{grid-row-start:1;}",
        ".fd46tj4{grid-column-start:2;}",
        ".fd7fpy0{visibility:hidden;}"
    ]
});
const useTabStyles_unstable = (state)=>{
    const rootStyles = useRootStyles();
    const focusStyles = useFocusStyles();
    const pendingIndicatorStyles = usePendingIndicatorStyles();
    const activeIndicatorStyles = useActiveIndicatorStyles();
    const iconStyles = useIconStyles();
    const contentStyles = useContentStyles();
    const { appearance , disabled , selected , size , vertical  } = state;
    state.root.className = (0, _react.mergeClasses)(tabClassNames.root, rootStyles.base, vertical ? rootStyles.vertical : rootStyles.horizontal, size === 'small' && (vertical ? rootStyles.smallVertical : rootStyles.smallHorizontal), size === 'medium' && (vertical ? rootStyles.mediumVertical : rootStyles.mediumHorizontal), size === 'large' && (vertical ? rootStyles.largeVertical : rootStyles.largeHorizontal), focusStyles.base, !disabled && appearance === 'subtle' && rootStyles.subtle, !disabled && appearance === 'transparent' && rootStyles.transparent, !disabled && selected && rootStyles.selected, disabled && rootStyles.disabled, // pending indicator (before pseudo element)
    pendingIndicatorStyles.base, size === 'small' && (vertical ? pendingIndicatorStyles.smallVertical : pendingIndicatorStyles.smallHorizontal), size === 'medium' && (vertical ? pendingIndicatorStyles.mediumVertical : pendingIndicatorStyles.mediumHorizontal), size === 'large' && (vertical ? pendingIndicatorStyles.largeVertical : pendingIndicatorStyles.largeHorizontal), disabled && pendingIndicatorStyles.disabled, // active indicator (after pseudo element)
    selected && activeIndicatorStyles.base, selected && !disabled && activeIndicatorStyles.selected, selected && size === 'small' && (vertical ? activeIndicatorStyles.smallVertical : activeIndicatorStyles.smallHorizontal), selected && size === 'medium' && (vertical ? activeIndicatorStyles.mediumVertical : activeIndicatorStyles.mediumHorizontal), selected && size === 'large' && (vertical ? activeIndicatorStyles.largeVertical : activeIndicatorStyles.largeHorizontal), selected && disabled && activeIndicatorStyles.disabled, state.root.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(tabClassNames.icon, iconStyles.base, iconStyles[size], selected && iconStyles.selected, state.icon.className);
    }
    // This needs to be before state.content.className is updated
    if (state.contentReservedSpaceClassName !== undefined) {
        state.contentReservedSpaceClassName = (0, _react.mergeClasses)(reservedSpaceClassNames.content, contentStyles.base, size === 'large' ? contentStyles.largeSelected : contentStyles.selected, state.icon ? contentStyles.iconBefore : contentStyles.noIconBefore, contentStyles.placeholder, state.content.className);
    }
    state.content.className = (0, _react.mergeClasses)(tabClassNames.content, contentStyles.base, size === 'large' && contentStyles.large, selected && (size === 'large' ? contentStyles.largeSelected : contentStyles.selected), state.icon ? contentStyles.iconBefore : contentStyles.noIconBefore, state.content.className);
    (0, _useTabAnimatedIndicator.useTabAnimatedIndicatorStyles_unstable)(state);
    return state;
}; //# sourceMappingURL=useTabStyles.js.map

//# sourceMappingURL=useTabStyles.js.map